module.exports = __webpack_public_path__ + "static/gatsby-astronaut-6d91c86c0fde632ba4cd01062fd9ccfa.png";